import React, { useState, useEffect } from 'react';
import { string, bool, shape } from 'prop-types';
import { Container } from '@material-ui/core';
import Image from '../../Image';
import styles from './style.module.scss';

const SingleImage = ({
  image,
  isAndroid,
  isWeb,
  mobileFullWidth,
  className,
  insideGrid,
  ...props
}) => {
  const [isMobile, setIsMobile] = useState(false);

  const resize = () => {
    if (window !== 'undefined') {
      setIsMobile(window.innerWidth < 599);
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', resize);
      setIsMobile(window.innerWidth < 599);
    }
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (insideGrid && (!isMobile || !mobileFullWidth) ? (
    <Container className={styles.container}>
      <Image
        source={image}
        alt="case"
        className={[
          styles.image,
          isAndroid && styles.imageAndroid,
          className,
        ].join(' ')}
        {...props}
      />
    </Container>
  ) : (
    <Image
      source={image}
      alt="case"
      className={[
        styles.image,
        isAndroid && styles.imageAndroid,
        className,
      ].join(' ')}
      {...props}
    />
  ));
};

SingleImage.propTypes = {
  image: shape({
    main: string,
    fall: string,
  }).isRequired,
  isAndroid: bool,
  isWeb: bool,
  className: string,
  insideGrid: bool,
  mobileFullWidth: bool,
};

SingleImage.defaultProps = {
  isAndroid: false,
  isWeb: false,
  className: null,
  insideGrid: false,
  mobileFullWidth: false,
};

export default SingleImage;
